import { call } from 'redux-saga/effects';

type ViewedAction = {
    type: string,
    id: string,
  };

export function* viewedProfile(action: ViewedAction): Generator<any, void, empty> {
  const actionId = action?.profileViewed;
  try {
    yield call(() => APIService.apiRequest('VIEWED_PROFILE', 'POST', {
      routeParams: {
        id: actionId,
      },
    }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);
  }
}

export function* viewedMyShot(action: ViewedAction): Generator<any, void, empty> {
  const actionId = action?.videoViewed;
  try {
    yield call(() => APIService.apiRequest('VIEWED_MYSHOT', 'POST', {
      routeParams: {
        id: actionId,
      },
    }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);
  }
}

export function* viewedResponse(action: ViewedAction): Generator<any, void, empty> {
  const actionId = action?.videoViewed;
  try {
    yield call(() => APIService.apiRequest('VIEWED_RESPONSE', 'POST', {
      routeParams: {
        id: actionId,
      },
    }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);
  }
}
